import { createUploadLink } from "apollo-upload-client"

export const createFileUploadEnabledLink = (
  fetchImplementation?: typeof fetch
) =>
  createUploadLink({
    uri: `${process.env.REACT_APP_BACKEND_URL}`,
    credentials: process.env.REACT_APP_CREDENTIALS,
    ...(fetchImplementation ? { fetch: fetchImplementation } : {})
  })

const fileUploadEnabledLink = createFileUploadEnabledLink()

export default fileUploadEnabledLink
